// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1KZV1","modalForm":"UpgradeEpcsModal_modalForm__2_tSW","modalFooter":"UpgradeEpcsModal_modalFooter__31R3D"};